import React from "react";
import {
    avatarColors,
    computeAge,
    getInitials,
    patientTitle,
    shortClassification,
    traitementCountLabel,
} from "./patientFormRules";

const badgeStyle = { fontSize: "11px", padding: "2px 8px", borderRadius: "4px" };

export default function PatientHeader({ patient, index, onRemove, onHistory }) {
    const { bg, color } = avatarColors(index);
    const age = computeAge(patient.dateNaissance);
    const hasClassification = patient.classification && patient.classification !== "UNKNOWN";

    return (
        <div className="commande-editor-patient-header" style={{ display: "flex", alignItems: "flex-start", gap: "14px", marginBottom: "20px" }}>
            <div style={{
                width: "48px", height: "48px",
                borderRadius: "12px",
                background: bg, color,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "17px", fontWeight: 700,
                flexShrink: 0,
            }}>
                {getInitials(patient.nom, patient.prenom)}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                    <h3 className="commande-editor-patient-title" style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#0f172a" }}>
                        {patientTitle(patient, index)}
                    </h3>
                    {age !== null && (
                        <span style={{ fontSize: "13px", color: "#94a3b8" }}>
                            · {age} ans
                        </span>
                    )}
                    {patient.pharmaceuticalValidated && (
                        <span style={{ ...badgeStyle, fontWeight: 700, background: "#dcfce7", color: "#15803d" }}>
                            Validé pharma
                        </span>
                    )}
                    {patient.managementValidated && !patient.pharmaceuticalValidated && (
                        <span style={{ ...badgeStyle, fontWeight: 700, background: "#e7f8f0", color: "#0C3B3C" }}>
                            Saisie validée
                        </span>
                    )}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px", flexWrap: "wrap" }}>
                    {hasClassification && (
                        <span data-testid="classification-badge" style={{ ...badgeStyle, fontWeight: 600, background: "#ede9fe", color: "#7c3aed" }}>
                            {shortClassification(patient.classification)}
                        </span>
                    )}
                    <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                        {traitementCountLabel((patient.produits || []).length)}
                    </span>
                </div>
            </div>

            <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                <button
                    type="button"
                    className="commande-editor-patient-history"
                    onClick={onHistory}
                    disabled={!patient.id}
                    title={patient.id ? "Voir les dernières commandes de ce patient" : "Enregistrez le patient pour consulter son historique"}
                >
                    Historique
                </button>
                <button
                    onClick={onRemove}
                    title="Supprimer le patient"
                    style={{
                        padding: "5px 10px", borderRadius: "6px",
                        border: "1px solid #fecaca", background: "#fff5f5",
                        color: "#ef4444", cursor: "pointer", fontSize: "12px", fontWeight: 500,
                    }}
                >
                    Supprimer
                </button>
            </div>
        </div>
    );
}
